import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { logError } from "@faire/web--source/common/logging";
import { Button } from "@faire/web--source/slate/Button";
import { PhoneInput } from "@faire/web--source/slate/Input/PhoneInput";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { useState } from "@faire/web--source/ui/hooks/useState";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import getEmailPreferences, { QueryParameters as EmailPreferencesParams } from "@faire/web-api--source/api/email/preferences/get";
import postEmailPreferences from "@faire/web-api--source/api/email/preferences/post";
import { useMutation as useMutationPatchUser } from "@faire/web-api--source/api/user/patch-hooks";
import { IUpdateEmailPreferencesRequest } from "@faire/web-api--source/com/faire/email/preferences/IUpdateEmailPreferencesRequest";
import { trackRetailersOptInNudgeSignUpCtaSuccess } from "@faire/web-api--source/events/retailers/success/optInNudgeSignUpCta";
import { trackRetailersOptInNudgesViewView } from "@faire/web-api--source/events/retailers/view/optInNudgesView";
import { MARKETING_EMAIL_OPT_IN_SUBMITTED } from "@faire/web-api--source/indigofair/data/IUserMilestone/RetailerMilestone/MARKETING_EMAIL_OPT_IN_SUBMITTED";
import { MARKETING_SMS_OPT_IN_SUBMITTED } from "@faire/web-api--source/indigofair/data/IUserMilestone/RetailerMilestone/MARKETING_SMS_OPT_IN_SUBMITTED";
import React from "react";
import styled from "styled-components";
import { PopupType } from "@faire/retailer-visitor-shared/components/App/PopupOptInNudge/PopupOptInNudge";
import { useMilestone } from "@faire/retailer-visitor-shared/stores/domain/useMilestone";
import { useUserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
export var optInOrigin;
(function(optInOrigin) {
    optInOrigin["POPUP_PROMPT"] = "POPUP_PROMPT";
    optInOrigin["POST_ORDER_PRIMARY"] = "POST_ORDER_PRIMARY";
    optInOrigin["POST_ORDER_SECONDARY"] = "POST_ORDER_SECONDARY";
    optInOrigin["FOOTER_PAGE"] = "FOOTER_PAGE";
})(optInOrigin || (optInOrigin = {}));
var SMSPostOptedIn = function() {
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Typography, {
                variant: "paragraphSansMedium",
                children: [
                    /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "kLb3w5",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "You\u2019re in!"
                            }
                        ]
                    }),
                    /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "GnrEne",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Look for your first SMS from us soon."
                            }
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "1x"
            })
        ]
    });
};
var EmailPostOptedIn = function() {
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraphSansMedium",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "noNqXt",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "You\u2019re in! Look for your first email soon."
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "1x"
            })
        ]
    });
};
export var OptInNudgeInput = function(param) {
    var origin = param.origin, onSuccess = param.onSuccess, _param_type = param.type, type = _param_type === void 0 ? PopupType.EMAIL : _param_type, savedPhoneNumber = param.savedPhoneNumber;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _useUserStore = useUserStore([
        "emailAddress",
        "userToken"
    ]), emailAddress = _useUserStore.emailAddress, userToken = _useUserStore.userToken;
    var _useMilestone = useMilestone(type === PopupType.EMAIL ? MARKETING_EMAIL_OPT_IN_SUBMITTED : MARKETING_SMS_OPT_IN_SUBMITTED), setOptInSubmitted = _useMilestone.setHasOccurred;
    var _useState = _sliced_to_array(useState(undefined), 2), error = _useState[0], setError = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), isLoading = _useState1[0], setIsLoading = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), hasSuccessfullyOptedIn = _useState2[0], setHasSuccessfullyOptedIn = _useState2[1];
    var _useState3 = _sliced_to_array(useState(savedPhoneNumber), 2), phoneNumber = _useState3[0], setPhoneNumber = _useState3[1];
    var ref = useDoActionWhenVisible(function() {
        if (origin) {
            trackRetailersOptInNudgesViewView(origin);
        }
    });
    var unsubscribeToAllEmailPreferenceGroups = function(emailPreferenceGroups) {
        var emailPreferenceGroupsClone = emailPreferenceGroups;
        emailPreferenceGroupsClone.forEach(function(emailPreferenceGroup) {
            emailPreferenceGroup.subgroups.forEach(function(subgroup) {
                subgroup.is_unsubscribed = false;
            });
        });
        return emailPreferenceGroupsClone;
    };
    var invalidPhoneNumberError = strictLocalize({
        id: "FPcbu0",
        defaultMessage: [
            {
                type: 0,
                value: "Please enter a valid phone number"
            }
        ]
    });
    var otherError = strictLocalize({
        id: "0Abtfk",
        defaultMessage: [
            {
                type: 0,
                value: "Something went wrong\u2014please try again."
            }
        ]
    });
    var _useMutationPatchUser = useMutationPatchUser({
        onSuccess: function() {
            if (origin) {
                trackRetailersOptInNudgeSignUpCtaSuccess(origin);
            }
            setOptInSubmitted();
            setHasSuccessfullyOptedIn(true);
            if (onSuccess) {
                onSuccess();
            }
            setIsLoading(false);
        },
        onError: function(error) {
            var _error_responseData;
            logError(error);
            if (((_error_responseData = error.responseData) === null || _error_responseData === void 0 ? void 0 : _error_responseData.service_error_code) === "UserValidationException.INVALID_PHONE_NUMBER") {
                setError(invalidPhoneNumberError);
            } else {
                setError(otherError);
            }
            setIsLoading(false);
        }
    }), updateUser = _useMutationPatchUser.mutate, isUpdatingUser = _useMutationPatchUser.isPending;
    var handleSMSOptInSubmission = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                setError(undefined);
                setIsLoading(true);
                updateUser([
                    {
                        token: userToken,
                        phone_number: phoneNumber,
                        marketing_sms_preference_change: "MARKETING_SMS_PREFERENCE_CHANGE_OPT_IN"
                    }
                ]);
                return [
                    2
                ];
            });
        });
        return function handleSMSOptInSubmission() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleEmailSubmission = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var email_preference_groups, e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setError(undefined);
                        setIsLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            5,
                            6
                        ]);
                        return [
                            4,
                            getEmailPreferences(EmailPreferencesParams.build({
                                outgoing_email: emailAddress
                            }))
                        ];
                    case 2:
                        email_preference_groups = _state.sent().email_preference_groups;
                        if (!email_preference_groups) {
                            setError(otherError);
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            postEmailPreferences(IUpdateEmailPreferencesRequest.build({
                                email_preference_groups: unsubscribeToAllEmailPreferenceGroups(email_preference_groups),
                                unsubscribe_from_all: false
                            }))
                        ];
                    case 3:
                        _state.sent();
                        if (origin) {
                            trackRetailersOptInNudgeSignUpCtaSuccess(origin);
                        }
                        setOptInSubmitted();
                        setHasSuccessfullyOptedIn(true);
                        if (onSuccess) {
                            onSuccess();
                        }
                        return [
                            3,
                            6
                        ];
                    case 4:
                        e = _state.sent();
                        logError(e);
                        setError(otherError);
                        return [
                            3,
                            6
                        ];
                    case 5:
                        setIsLoading(false);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleEmailSubmission() {
            return _ref.apply(this, arguments);
        };
    }();
    if (hasSuccessfullyOptedIn) {
        return type === PopupType.SMS ? /*#__PURE__*/ _jsx(SMSPostOptedIn, {}) : /*#__PURE__*/ _jsx(EmailPostOptedIn, {});
    }
    if (type === PopupType.SMS) {
        return /*#__PURE__*/ _jsxs("div", {
            ref: ref,
            children: [
                /*#__PURE__*/ _jsx(PhoneInput, {
                    label: strictLocalize({
                        id: "WJpIG3",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Mobile phone number"
                            }
                        ]
                    }),
                    helper: strictLocalize({
                        id: "72Jtlj",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Standard messaging rates apply. Opt out anytime."
                            }
                        ]
                    }),
                    error: error,
                    onChangePhoneNumber: setPhoneNumber,
                    defaultPhoneNumber: phoneNumber
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "2x"
                }),
                /*#__PURE__*/ _jsx(StyledButton, {
                    variant: "primary",
                    loading: isLoading,
                    onClick: handleSMSOptInSubmission,
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "1RUD5s",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Opt into SMS"
                            }
                        ]
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsxs("div", {
        ref: ref,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraphSansRegular",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "0wcaRo",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Email address"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraphSansMedium",
                children: emailAddress
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "2x"
            }),
            error ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "labelSansRegular",
                        color: Core.text.critical,
                        children: error
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "1x"
                    })
                ]
            }) : null,
            /*#__PURE__*/ _jsx(StyledButton, {
                variant: "primary",
                loading: isLoading || isUpdatingUser,
                onClick: handleEmailSubmission,
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "PnMTXY",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Opt in to email"
                        }
                    ]
                })
            })
        ]
    });
};
var StyledButton = styled(Button).withConfig({
    componentId: "sc-80e83a67-0"
})([
    "width:100%;"
]);
